"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _uiUtils = require("@airasia/ui-utils");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _reactNativeWeb = require("react-native-web");

var _AaHelpers = require("../../../utils/AaHelpers");

var _AaPlatform = _interopRequireDefault(require("../../../utils/AaPlatform"));

var _AaSuggestionsRequestParams = require("../../../utils/AaSuggestionsRequestParams");

var _stateVariables = _interopRequireDefault(require("../../../config/stateVariables"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AaPicker = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AaPicker, _React$Component);

  var _super = _createSuper(AaPicker);

  function AaPicker(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AaPicker);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateFilterState", function () {
      var suggestions = (0, _get2["default"])(_this.props.async_suggestions, 'userData.data.suggestions', []);
      var _this$props$translati = _this.props.translation,
          otherListsLabel = _this$props$translati.otherListsLabel,
          noResultLabel = _this$props$translati.noResultLabel,
          suggestionTypes = _this$props$translati.suggestionTypes;
      var transformedSuggestions = (0, _AaHelpers.transformSuggestions)(suggestions, suggestionTypes);
      var title = (0, _isEmpty2["default"])(suggestions) ? noResultLabel : otherListsLabel;

      _this.props.onLoadSuggestions(_this.state.filteredText, transformedSuggestions);

      _this.setState({
        filteredSuggestions: [{
          data: transformedSuggestions,
          title: title
        }]
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "DELAY_SEARCH_SUGGESTIONS", 250);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fetchSuggestions", (0, _debounce2["default"])( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(query) {
        var locale, suggestionParamsBuilder, headers, formatedUrl;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                locale = _this.props.locale;
                suggestionParamsBuilder = (0, _AaSuggestionsRequestParams.getParamsBuilder)();
                _context.next = 4;
                return suggestionParamsBuilder.buildHeaders();

              case 4:
                headers = _context.sent;
                formatedUrl = suggestionParamsBuilder.getSuggestionsUrl(query, locale);

                _this.props.make_async_get_call(formatedUrl, headers, _stateVariables["default"].suggestions);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this.DELAY_SEARCH_SUGGESTIONS));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeHandler", function (input) {
      if (!(0, _isEmpty2["default"])(input) && input.length >= _this.props.minQueryFetchLength) {
        _this.fetchSuggestions(input);

        _this.setState({
          filteredText: input
        });
      } else {
        _this.setState({
          displaySectionHeader: true,
          filteredSuggestions: _this.state.recentSearchesSuggestions
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOriginState", function (value) {
      _this.props.updateMasterState(value);

      _this.changeHandler(value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onInputFocus", function (bool) {
      _this.setState({
        focus: bool
      });

      if (_this.state.isStationApiFailed) {
        _this.setState({
          filteredSuggestions: [{
            title: _this.props.translation.apiDownLabel,
            data: []
          }]
        });
      } else {
        _this.props.onInputFocus(bool);

        if (_AaPlatform["default"].IS_WEB || _this.props.layout <= _crossPlatformComponents.LAYOUT.mobile) {
          if (!bool) {
            if (_this.state.filteredSuggestions.data && _this.state.filteredSuggestions.data.length > 0) {
              _this.changeHandler(_this.props.value);
            }
          } else {
            _this.changeHandler("");
          }
        } else {
          _this.changeHandler("");
        }

        if (!bool) {
          if (_AaPlatform["default"].IS_WEB) {
            //Set Destination value accordingly
            if (!_this.props.value) {
              _this.props.isDestinationValid(false);

              _this.setState({
                invalidInput: true
              });
            }
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOriginSelection", function (key, index) {
      _this.props.onOptionPress(key, index + 1);

      _this.props.isDestinationValid(true);

      _this.setState({
        invalidInput: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "directFocusEntity", function (_boolean) {
      _this.props.openSearchWidgetModalMobileView(_boolean);
    });
    _this.state = {
      filteredSuggestions: [],
      recentSearchesSuggestions: [],
      filteredText: null,
      recentSearches: _this.props.recentSearches,
      displaySectionHeader: true,
      isStationApiFailed: false,
      focus: false,
      invalidInput: false
    };
    return _this;
  }

  (0, _createClass2["default"])(AaPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          showFormErrors = _this$props.showFormErrors,
          value = _this$props.value;
      var showFormErrorsChange = showFormErrors && !prevProps.showFormErrors;

      if (showFormErrorsChange && !value) {
        this.setState({
          invalidInput: true
        });
      }

      if (prevProps.recentSearches !== this.props.recentSearches || prevProps.recentSearchesResult !== this.props.recentSearchesResult || prevProps.async_all_station_data !== this.props.async_all_station_data) {
        if (this.props.recentSearches) {
          if (this.props.recentSearchesResult) {
            var recentSearchesResult = this.props.recentSearchesResult;
            var RECENT_SEARCHES = [{
              title: this.props.translation.destinationRecentSearchesLabel,
              data: recentSearchesResult
            }];
            this.setState({
              filteredSuggestions: RECENT_SEARCHES,
              recentSearchesSuggestions: RECENT_SEARCHES
            });
          }
        } else if (this.props.nearestAirport && this.props.originStationListWithIcons) {
          if (this.props.async_nearest_airports && this.props.async_nearest_airports["userData"].hasOwnProperty("data")) {
            if (this.props.async_all_station_data["userData"].data) {
              console.log("Added try/catch block");

              try {
                var nearest_airport = this.props.async_nearest_airports["userData"].data;
                var nearestAirports = nearest_airport["airport"].map(function (cityCode) {
                  return (0, _AaHelpers.getStationObjectFromCode)(cityCode, _this2.props.originStationListWithIcons);
                });
                nearestAirports = nearestAirports.filter(function (n) {
                  return n;
                });
                var NEAREST_AIRPORTS = [{
                  title: this.props.translation.nearestAirportLabel,
                  data: (0, _AaHelpers.addNearestAirportLocationIcon)(nearestAirports)
                }];
                this.setState({
                  nearestAirportSuggestions: NEAREST_AIRPORTS
                });
                this.props.setNearestAirport(nearestAirports[0]);
                /*
                 * Passing nearest Airport to AaPlacepicker
                 */

                this.props.getNearestAirport(nearestAirports);
              } catch (err) {
                //just log message
                //No Logic here
                console.log(err);
              }
            }
          }
        }
      }

      var wasFetchingSuggestions = !this.props.isFetchingSuggestions && prevProps.isFetchingSuggestions;

      if (wasFetchingSuggestions) {
        this.updateFilterState();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          layout = _this$props2.layout,
          forceMobileView = _this$props2.forceMobileView;
      var isMobileLayout = forceMobileView || layout <= _crossPlatformComponents.LAYOUT.mobile;
      var isMobilePlatform = _AaPlatform["default"].IS_MOBILE;
      var labelContainerStyles = {
        paddingVertical: 8,
        paddingHorizontal: 15
      };
      var mainWrapperStyles = {
        flex: 1,
        marginRight: -1
      };

      if (_AaPlatform["default"].IS_WEB && this.props.layout > _crossPlatformComponents.LAYOUT.mobile && this.state.focus) {
        mainWrapperStyles.position = 'relative';
        mainWrapperStyles.zIndex = '1000';
      }

      ;

      if (isMobileLayout) {
        labelContainerStyles.paddingVertical = 15;
      }

      var textInputWithNoBorder = this.props.mobileScreenWeb ? styles.textInputWithNoBorder : styles.textInputContainerMob;
      return /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
        style: mainWrapperStyles
      }, /*#__PURE__*/React.createElement(_crossPlatformComponents.AaAutoCompleteComponent, {
        controls: {
          directFocusEntity: this.directFocusEntity,
          isNewDesign: this.props.isNewDesign,
          textInputControls: {
            controls: {
              attrName: 'origin',
              value: this.props.value,
              updateMasterState: this.updateOriginState,
              isFloatingLabelRequired: true,
              onInputFocus: this.onInputFocus,
              textInputStyles: styles.textInputStyles,
              textInputContainerStyle: textInputWithNoBorder,
              selectTextOnFocus: true,
              inputReference: this.props.inputReference
            },
            translation: {
              title: this.props.translation.originTitleLabel,
              placeholder: this.props.translation.originPlaceholderLabel
            }
          },
          dropDownControls: {
            controls: {
              value: this.props.value,
              isListLoading: this.props.isFetchingSuggestions,
              primaryLabel: 'name',
              secondaryLabel: 'code',
              subtitleLabel: 'subtitle',
              onOptionPress: this.onOriginSelection,
              labelContainerStyles: labelContainerStyles,
              customListStyles: styles.dropdown,
              filteredText: this.state.filteredText,
              displaySectionHeader: this.state.displaySectionHeader
            },
            data: this.state.filteredSuggestions
          },
          isMobilePlatform: isMobilePlatform,
          isMobileLayout: isMobileLayout,
          invalidInput: this.state.invalidInput
        }
      }));
    }
  }]);
  return AaPicker;
}(React.Component);

var styles = _crossPlatformComponents.StyleSheet.create({
  textInputWithNoBorder: {
    borderWidth: 0,
    borderRadius: 0,
    borderRightWidth: 0.5
  },
  textInputStyles: {
    color: '#212124',
    fontWeight: '500',
    android: {
      fontWeight: '400',
      color: '#212124'
    },
    ios: {
      fontWeight: '400',
      color: '#212124'
    }
  },
  textInputContainerMob: {
    borderRadius: 4
  },
  dropdown: {
    web: {
      maxHeight: 350,
      borderColor: "#fff",
      borderRadius: 4,
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84
    },
    backgroundColor: 'rgba(255,149,158,0.05)',
    zIndex: 999
  }
});

var mapStateToProps = function mapStateToProps(state) {
  var locale = state.updatedState.locale;
  var async_suggestions = (0, _get2["default"])(state.asyncAction, _stateVariables["default"].suggestions, {});
  return {
    locale: locale,
    isFetchingSuggestions: async_suggestions.isFetching,
    sharedLabel: state.asyncAction[_stateVariables["default"].shared_component],
    async_nearest_airports: state.asyncAction[_stateVariables["default"].nearest_airports],
    async_suggestions: async_suggestions
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  make_async_get_call: _uiUtils.make_async_get_call
})(AaPicker);

exports["default"] = _default;